export const userValidationErrors: { [key: string]: string } = {
  EMAIL_INVALID: "E-mail is not valid",
  EMAIL_ALREADY_EXISTS: "E-mail already exists",
  UNKNOWN_ROLE: "Unknown role",
};
